module.exports = __webpack_public_path__ + "img/04.f65d0065.png";